import React from 'react';
import { type Coverage, CoverageSection } from './Coverage';

export interface CoveragesProps {
  title: string;
  subtitle: string;
  data: Coverage[];
  darkBackground?: boolean;
}

const Coverages: React.FC<CoveragesProps> = ({ data, title, subtitle, darkBackground }) => {
  return <CoverageSection title={title} subtitle={subtitle} coverages={data} darkBackground={darkBackground} />;
};

export default React.memo(Coverages);
